<template>
  <div id="canvas-container">
    <script type="x-shader/x-vertex" id="vertexShader">
      attribute vec3 center; varying vec3 vCenter; void main() { vCenter = center; gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 ); }
    </script>

    <script type="x-shader/x-fragment" id="fragmentShader">
      varying vec3 vCenter; uniform float lineWidth;
      float edgeFactorTri() {
      vec3 d = fwidth( vCenter.xyz );
      vec3 a3 = smoothstep( vec3( 0.0 ), d * lineWidth, vCenter.xyz );
      return min( min( a3.x, a3.y ), a3.z ); }
    void main() {
      float factor = edgeFactorTri();
      if ( factor > 0.8 ) discard; // <===============
      gl_FragColor.rgb = mix( vec3(
      1.0 ), vec3( 0.2 ), factor);
      gl_FragColor.a = 1.0;
    }
    </script>
  </div>
  <!-- <div id="container" @mousedown="onMouseClick"></div> -->
</template>

<script>
import * as THREE from 'three'
import * as MeshLine from 'three.meshline'
import {extrudePolygon} from 'geometry-extrude'
// import * as PIXI from "pixi.js"

export default {
  name: 'ThreejsScene',
  props: ['mouse', 'screenSize'],
  data () {
    return {
      camera: null,
      scene: null,
      renderer: null,
      root: null,
      box: null,
      sphere: null,
      THREE_TEXTURE: null,
      // cameraBasicPos: 0
      // fadeTo: 1
    }
  },
  computed: {
    fadeTo: function() {
      if(this.$route.path === "/") {
        return 1;
      } else {
        return 1;
      }
    },
    cameraBasicPos: function () {
      if(this.$route.path === "/") {
        return 0;
      } else if(this.$route.path.indexOf("/works") !== -1) {
        return 1;
      } else if(this.$route.path.indexOf("/experiments") !== -1) {
        return 2;
      } else if(this.$route.path.indexOf("/about") !== -1) {
        return 3;
      }
      return 0;
    },
    isPause: function(){
      return this.$route.path.split('/').length > 2;
    }
  },
  methods: {
    init: function () {
      var container = document.getElementById('canvas-container')

      this.camera = new THREE.PerspectiveCamera(70, this.screenSize.width / this.screenSize.height, 0.01, 10)
      this.camera.position.z = 1

      this.scene = new THREE.Scene()
      this.camera.lookAt(this.scene.position)

      this.root = new THREE.Group();
      this.scene.add(this.root);

      const near = 1;
      const far = 10;
      const color = 0x000000;
      this.scene.fog = new THREE.Fog(color, near, far);
      // scene.background = new THREE.Color(color);


      // grid
      var gridHelper = new THREE.GridHelper( 20, 40 );
      gridHelper.position.y = -0.5
      this.scene.add( gridHelper );

      var gridHelper = new THREE.GridHelper( 20, 40 );
      gridHelper.position.y = 0.5
      this.scene.add( gridHelper );



      var geometry = new THREE.BoxBufferGeometry(0.3, 0.3, 0.3)
      var material = new THREE.MeshNormalMaterial()

      // this.mesh = new THREE.Mesh(geometry, material)

      // var wireframe = new THREE.WireframeGeometry( geometry );

      // var material = new THREE.LineBasicMaterial( {
      //   color: 0xffffff,
      //   linewidth: 1
      // } );
      // this.mesh = new THREE.LineSegments( wireframe , material);
      // this.mesh.material.depthTest = false;
      // this.mesh.material.opacity = 1;
      // this.mesh.material.transparent = true;

      // var material = new THREE.MeshBasicMaterial({
      //   color: 0xffffff,
      //   wireframe: true
      // });

      var material = new THREE.MeshBasicMaterial({
        color: 0x000000,
        transparent: true,
        opacity: this.fadeTo
      });

      var mesh = new THREE.Mesh(geometry, material);

      var edges = new THREE.EdgesGeometry( geometry );
      var line = new THREE.LineSegments( edges, new THREE.LineBasicMaterial( { color: 0xffffff, transparent: true, opacity: this.fadeTo } ) );
      // console.log(line);

      // var uniforms = { 'widthFactor': { value: 40 } };
      // var material = new THREE.ShaderMaterial( {
      //   uniforms: uniforms,
      //   vertexShader: document.getElementById( 'vertexShader' ).textContent,
      //   fragmentShader: document.getElementById( 'fragmentShader' ).textContent,
      //   side: THREE.DoubleSide
      // } );
      // material.extensions.derivatives = true;

      // edges.removeAttribute( 'normal' );
      // edges.removeAttribute( 'uv' );
      // setupAttributes( edges );
      // var mesh2 = new THREE.Mesh( edges, material );

      // function setupAttributes( geometry ) {
			// 	var vectors = [
			// 		new THREE.Vector3( 1, 0, 0 ),
			// 		new THREE.Vector3( 0, 1, 0 ),
			// 		new THREE.Vector3( 0, 0, 1 )
			// 	];
			// 	var position = geometry.attributes.position;
			// 	var centers = new Float32Array( position.count * 3 );
			// 	for ( var i = 0, l = position.count; i < l; i ++ ) {
			// 		vectors[ i % 3 ].toArray( centers, i * 3 );
			// 	}
			// 	geometry.addAttribute( 'center', new THREE.BufferAttribute( centers, 3 ) );
			// }


      this.box = new THREE.Group();

      this.box.add(mesh)
      this.box.add(line)

      // this.box.add( mesh2 );

      this.root.add(this.box)


      var geometry = new THREE.SphereGeometry( 1.5, 32, 32 );
      var material = new THREE.MeshBasicMaterial({
        transparent: true, opacity : 0
      });
      // var material = new THREE.MeshNormalMaterial();
      material.side = THREE.DoubleSide;
      var sphere = new THREE.Mesh( geometry, material );
      this.scene.add( sphere );

      this.sphere = sphere;

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      this.renderer.setClearColor(0x000000, 0);
      this.renderer.setSize(this.screenSize.width, this.screenSize.height);
      if(this.screenSize.width < 800 && window.devicePixelRatio >= 2) {
        this.renderer.setPixelRatio(2);
      }


      // this.renderer.autoClearColor = false;
      container.appendChild(this.renderer.domElement)

    },
    animate: function () {
      requestAnimationFrame(this.animate)
      if(this.isPause) return;

      this.camera.position.x = this.lerp(this.camera.position.x, this.cameraBasicPos + this.mouse.x * 0.001, 0.1);
      this.camera.position.y = this.lerp(this.camera.position.y, -this.mouse.y * 0.0005, 0.1);

      // console.log(this.mouse.x * 0.01);

      this.camera.lookAt(this.scene.position);


      this.root.rotation.x += 0.01
      this.root.rotation.y += 0.02


      // this.box.children[0].material.opacity = this.lerp(this.box.children[0].material.opacity, this.fadeTo, 0.03);
      // this.box.children[1].material.opacity = this.lerp(this.box.children[1].material.opacity, this.fadeTo, 0.03);

      this.renderer.render(this.scene, this.camera)

      // console.log(this.container.clientWidth);

    },
    resize: function() {
      var vw = this.screenSize.width;
      var vh = this.screenSize.height;

      this.camera.aspect = vw / vh;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(vw, vh);
    },
    onMouseClick: function ( event ) {
      event.preventDefault();

      var raycaster = new THREE.Raycaster();
      var mouse = new THREE.Vector2();
      mouse.set( ( event.clientX / window.innerWidth ) * 2 - 1, - ( event.clientY / window.innerHeight ) * 2 + 1 );
      raycaster.setFromCamera( mouse, this.camera );
      var intersects = raycaster.intersectObjects( [this.sphere] );
      if ( intersects.length > 0 ) {

        var intersect = intersects[ 0 ];

        var geometry = new THREE.BoxGeometry(0.1, 0.1, 0.1)
        var material = new THREE.MeshBasicMaterial({
          color: 0x000000
        });

        var mesh = new THREE.Mesh(geometry, material);

        var edges = new THREE.EdgesGeometry( geometry );
        var line = new THREE.LineSegments( edges, new THREE.LineBasicMaterial( { color: 0xffffff } ) );

        mesh.position.copy( intersect.point )
        line.position.copy( intersect.point )

        this.root.attach(mesh)
        this.root.attach(line)
      }

    },
    lerp: function(start, end, amt){
      return (1-amt)*start+amt*end
    },
  },
  mounted () {
    this.init()
    this.animate()
  },
  watch: {
    'screenSize.width' (to, from) {
      this.resize();
    },
    'screenSize.height' (to, from) {
      this.resize();
    }
  }
}

</script>
<style lang="sass" scoped>
#canvas-container
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  margin: 0
  padding: 0
  overflow: hidden

</style>



// WEBPACK FOOTER //
// src/components/ThreejsScene.vue